// Flow-Kurzskala (FKS) Questions
// Based on Rheinberg, Vollmeyer & Engeser (2019)

export const flowQuestions = [
  // Flow Core Items (1-10)
  {
    id: 'q1',
    text: 'Ich fühle mich optimal beansprucht.',
    type: 'scale',
    category: 'absorption',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q2',
    text: 'Meine Gedanken bzw. Aktivitäten laufen flüssig und glatt.',
    type: 'scale',
    category: 'fluency',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q3',
    text: 'Ich merke gar nicht, wie die Zeit vergeht.',
    type: 'scale',
    category: 'absorption',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q4',
    text: 'Ich habe keine Mühe, mich zu konzentrieren.',
    type: 'scale',
    category: 'absorption',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q5',
    text: 'Mein Kopf ist völlig klar.',
    type: 'scale',
    category: 'fluency',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q6',
    text: 'Ich bin ganz vertieft in das, was ich gerade mache.',
    type: 'scale',
    category: 'absorption',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q7',
    text: 'Die richtigen Gedanken/Bewegungen kommen wie von selbst.',
    type: 'scale',
    category: 'fluency',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q8',
    text: 'Ich weiß bei jedem Schritt, was ich zu tun habe.',
    type: 'scale',
    category: 'fluency',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q9',
    text: 'Ich habe das Gefühl, den Ablauf unter Kontrolle zu haben.',
    type: 'scale',
    category: 'fluency',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q10',
    text: 'Ich bin völlig selbstvergessen.',
    type: 'scale',
    category: 'absorption',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  // Worry Items (11-13)
  {
    id: 'q11',
    text: 'Es steht etwas für mich Wichtiges auf dem Spiel.',
    type: 'scale',
    category: 'worry',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q12',
    text: 'Ich darf jetzt keine Fehler machen.',
    type: 'scale',
    category: 'worry',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  {
    id: 'q13',
    text: 'Ich mache mir Sorgen über einen Misserfolg.',
    type: 'scale',
    category: 'worry',
    options: ['Trifft nicht zu', 'Trifft wenig zu', 'Teils-teils', 'Trifft eher zu', 'Trifft zu']
  },
  // Additional Items (14-16)
  {
    id: 'q14',
    text: 'Verglichen mit allen anderen Tätigkeiten, die ich sonst mache, ist die jetzige Tätigkeit...',
    type: 'difficulty',
    category: 'challenge',
    options: ['Leicht', 'Eher leicht', 'Mittel', 'Eher schwer', 'Schwer']
  },
  {
    id: 'q15',
    text: 'Ich denke, meine Fähigkeiten auf diesem Gebiet sind...',
    type: 'ability',
    category: 'skill',
    options: ['Niedrig', 'Eher niedrig', 'Mittel', 'Eher hoch', 'Hoch']
  },
  {
    id: 'q16',
    text: 'Für mich persönlich sind die jetzigen Anforderungen...',
    type: 'demand',
    category: 'fit',
    options: ['Zu gering', 'Eher zu gering', 'Gerade richtig', 'Eher zu hoch', 'Zu hoch']
  }
];